export default "__VITE_ASSET__2b84c692__"